import React from 'react';
import PropTypes from 'prop-types';

import style from './RadioButton.module.css';

const RadioButton = React.memo(
  ({
    name,
    value,
    label,
    checked = false,
    styles = {},
    labelStyles = {},
    onChange
  }) => {
    return (
      <div className={style.main} style={styles}>
        <input
          name={name}
          value={value}
          className={style.radioButton}
          type="radio"
          checked={checked}
          onChange={onChange}
        />
        <div style={labelStyles}>{label}</div>
      </div>
    );
  },
);

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  styles: PropTypes.shape({}),
  labelStyles: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

export default RadioButton;
